import { useState } from "react";

export function useLocalStorageState<T>(key: string, val: T) {
  const [state, setState] = useState((getFromLocalStorage(key) as T) ?? val);
  const set = (val: T) => {
    setState(val);
    setToLocalStorage(key, val);
  };

  return { state, set };
}

function getFromLocalStorage<R>(key: string) {
  const sessionStorageValue = window.localStorage.getItem(key);
  if (!sessionStorageValue) return;
  return parseJSON(sessionStorageValue) as R;
}

function setToLocalStorage<T>(key: string, value: T) {
  const stringifiedValue = stringifyJSON(value);
  if (!stringifiedValue) return;
  window.localStorage.setItem(key, stringifiedValue);
}

function stringifyJSON<T>(val: T) {
  try {
    return JSON.stringify(val);
  } catch (error) {
    console.error(error);
  }
}

function parseJSON(val: string) {
  try {
    return JSON.parse(val) as unknown;
  } catch (error) {
    console.error(error);
  }
}
